<template>
  <v-tabs
          color="basil"
          grow
          class="chat-app__flex-box"
  >
    <v-tab href="#chat" active-class="chat-app__tab_active">
      {{ getChatLabel() }}
    </v-tab>
    <v-tab-item value="chat">
      <div class="chat-app__wrapper_inner">
        <ChatMessages :on-delete="onDelete"
                      :on-mark-attention="onMarkAttention"
                      :on-unmark-attention="onUnmarkAttention"
                      :on-mark-question="onMarkQuestion"
                      :on-unmark-question="onUnmarkQuestion"
                      :on-ban="onBan"
                      :on-like="onLike"
                      :on-dislike="onDislike"
        />
      </div>
    </v-tab-item>

    <v-tab href="#questions">
      {{ getQuestionsLabel() }}
    </v-tab>
    <v-tab-item value="questions">
      <ChatQuestions :on-delete="onDelete"
                     :on-mark-attention="onMarkAttention"
                     :on-unmark-attention="onUnmarkAttention"
                     :on-unmark-question="onUnmarkQuestion"
                     :on-like="onLike"
                     :on-dislike="onDislike"

      />
    </v-tab-item>
  </v-tabs>
</template>

<script>
  import ChatMessages from "./ChatMessages";
  import ChatQuestions from "./ChatQuestions";
  import {localize} from "@/store/modules/localization";

  export default {
    name: "Chat",
    components: {ChatMessages, ChatQuestions},
    computed: {
      getCount() {
        return this.$store.getters.getUsersCount
      }
    },
    methods: {
      sendMsg (cmd, body, additional) {
        this.$store.dispatch('sendWsMsg', {cmd, body, ...additional})
      },
      onDelete (msg) {
        this.sendMsg('mark_deleted', `${msg.id}`)
      },
      onMarkAttention (msg) {
        this.sendMsg('mark_important', `${msg.id}`)
      },
      onUnmarkAttention (msg) {
        this.sendMsg('unmark_important', `${msg.id}`)
      },
      onMarkQuestion (msg) {
        this.sendMsg('mark_question', `${msg.id}`)
      },
      onUnmarkQuestion (msg) {
        this.sendMsg('unmark_question', `${msg.id}`)
      },
      onBan (msg) {
        this.sendMsg('revoke_write', `${msg.sender.uid}`)
        this.sendMsg('mark_deleted', `${msg.id}`)
      },
      onLike(msg) {
        msg.liked = true
        this.sendMsg('like', `${msg.id}`)
      },
      onDislike(msg) {
        msg.liked = false
        this.sendMsg('dislike', `${msg.id}`)
      },
      getChatLabel() {
        const hasRight = this.$store.getters.amIModerator || !this.$settings.hideuserscount
        const count = hasRight ? `(${this.getCount})` : ''
        return localize('Chat', this.$settings.lang) + `${count}`
      },
      getQuestionsLabel() {
        return localize('Questions', this.$settings.lang)
      }
    },
    created() {
      const vm = this
      this.$store.dispatch('connectWebsocket', vm)
      if (!this.$settings.hideuserscount) this.$store.dispatch('setUserCountInterval')
    }
  }
</script>
